import React, { useState, useEffect } from "react";
import { Form, Typography, Row, Col, Checkbox, Carousel, Radio } from "antd";
import placeholder from "../../../../../../assets/vehicle-placeholder.jpg";
import PriceTable from "./PriceTable";
import TaxTable from "./TaxTable";
// import { types } from "@babel/core";

const { Item } = Form;
const { Text } = Typography;

const PriceModal = ({
  form,
  open,
  editable,
  data,
  validityRef,
  selectedId,
  isCheckedInsurance,
  onTotalChange, 
}) => {
  const [priceList, setPriceList] = useState({ total: undefined });
  const [vehicle, setVehicle] = useState(null);
  const [price, setPrice] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [colorSelected, setColorSelected] = useState([]);
  const [insuranceChecked, setInsuranceChecked] = useState([]);
  const [otherChecked, setOthersChecked] = useState([]);

  const { getFieldDecorator, resetFields, setFieldsValue } = form;

  const insTypes = [
    { key: "insurance1plus5", title: "1+5" },
    { key: "insurance1plus5ZD", title: "1+5 Zero Dep" },
  ];

  const others = [
    { key: "warrantyPrice", title: "Extended Warranty" },
    { key: "amc", title: "Amc" },
    { key: "rsa", title: "Rsa" },
    { key: "otherCharges", title: "Other Charges" },
    { key: "discount", title: "Discount" },
  ];

  const priceType = [
    { key: "showroomPrice", title: "Ex-Showroom Price" },
    { key: "roadTax", title: "Road Tax" },
    { key: "handlingCharges", title: "Handling Charges" },
    { key: "registrationFee", title: "Registration Fee" },
    // { key : "rto", title:"RTO" },
    { key: "tcs", title: "Tcs" },
  ];
   useEffect(() => {
    // Notify parent component when total changes and is a valid number
    if (onTotalChange && priceList.total && priceList.total > 0) {
      onTotalChange(priceList.total);
    }
  }, [priceList.total, onTotalChange]);
  // useEffect(()=>{
  //   console.log("selected")
  //   console.log(selectedId)
  //   console.log(data);
  // },[selectedId]);

  useEffect(() => {
    validityRef.current = () => {
      return handleSubmit();
    };
    return () => {
      validityRef.current = null;
    };
  });

  useEffect(() => {
    if (open) {
      selectInsurance([]);
      if (data || selectedId) {
        const {
          vehicleDetail,
          insuranceType,
          optionalType,
          price = selectedId,
        } = data;

        if (vehicleDetail) {
          console.log("vehicle detail:",vehicleDetail);
          
          selectedId
            ? setVehicle(vehicleDetail.model)
            : setVehicle(vehicleDetail);
          if (price) {
            setPrice(price);
            const total = fetchPrice(price);
            if (insuranceType) {
              console.log("insurance type:",insuranceType);
              
              const insurance = insuranceType.map((insure) => {
                return insure.type;
              });
              setInsuranceChecked(insurance);
              selectInsurance(insurance);
              // setFieldsValue({ insurance });
              var others = null;
              if (optionalType) {
                others = optionalType.map((optional) => {
                  return optional.type;
                });
                setOthersChecked(others);
                // setFieldsValue({ others });
                // calculateOthersTotal(others, price, { total });
              }
              calculateTotal(insurance, others, price, { total });
            }
            // if (optionalType) {
            //   others = optionalType.map((optional) => {
            //     return optional.type;
            //   });
            //   setOthersChecked(others);
            //   // setFieldsValue({ others });

            //   // calculateOthersTotal(others, price, { total });
            // }
          }
        }
      }
    } else {
      form.resetFields();
      setPriceList({ total: undefined });
      setVehicle(null);
      setDataSource([]);
      setInsuranceChecked([]);
      setOthersChecked([]);
      resetFields();
    }
  }, [open, data]);

  const handleSubmit = () => {
    let error;
    form.validateFields((validationError) => {
      error = validationError === null;
      if (error) {
        const insurance = [];
        const optional = [];
        if (!data.color) {
          data.color = vehicle.image[0].id;
        }
        insTypes.forEach((types) => {
          if (insuranceChecked.includes(types.key)) {
            insurance.push({
              type: types.key,
              amount: (priceList[types.key] || priceList.total) - priceList.total,
              onRoad: priceList[types.key] || priceList.total,
            });
          }
        });
        others.forEach((val) => {
          if (priceList[val.key]) {
            optional.push({
              type: val.key,
              amount: priceList[val.key],
            });
          }
        });
        data.optionalType = optional;
        data.insuranceType = insurance;
      }
    });
    return error;
  };

  const calculateTotal = (
    checked,
    optional,
    mockPrice = {},
    mockTotal = {}
  ) => {
    setCheckedList(checked);
    setInsuranceChecked(checked);
    const loadedPrice = mockPrice.id ? mockPrice : price;
    let prices = mockTotal.total ? mockTotal : priceList;
    insTypes.forEach((types) => {

      if (prices[types.key]) {
        delete prices[types.key];
      }

      if (checked.includes(types.key)) {
        prices = {
          ...prices,
          [types.key]: prices.total + (parseFloat(loadedPrice[types.key]) || 0),
        };
      }
    });
    if (optional) {
      others.forEach((type) => {
        if (prices[type.key]) {
          delete prices[type.key];
        }
        if (optional.includes(type.key)) {
          prices = {
            ...prices,
            total:
              type.key === "discount"
                ? prices.total - (parseFloat(loadedPrice[type.key]) || 0)
                : prices.total + (parseFloat(loadedPrice[type.key]) || 0),
          };
          if (checked.includes("insurance1plus5")) {
            prices = {
              ...prices,
              insurance1plus5: prices.total + (parseFloat(loadedPrice.insurance1plus5) || 0),
            };
          }
          if (checked.includes("insurance5plus5")) {
            prices = {
              ...prices,
              insurance5plus5: prices.total + (parseFloat(loadedPrice.insurance5plus5) || 0),
            };
          }
          if (checked.includes("insurance1plus5ZD")) {
            prices = {
              ...prices,
              insurance1plus5ZD: prices.total + (parseFloat(loadedPrice.insurance1plus5ZD) || 0),
            };
          }
          if (checked.includes("insurance5plus5ZD")) {
            prices = {
              ...prices,
              insurance5plus5ZD: prices.total + (parseFloat(loadedPrice.insurance5plus5ZD) || 0),
            };
          }
        }
      });
    }

    setPriceList({ ...prices });
  };

  const calculateAMCRSATotal = (checked, mockPrice = {}, mockTotal = {}) => {
    const loadedPrice = mockPrice.id ? mockPrice : price;
    let prices = mockTotal.total ? mockTotal : { ...priceList };

    const newlyChecked = checked.filter((key) => !otherChecked.includes(key));
    const newlyUnchecked = otherChecked.filter((key) => !checked.includes(key));

    newlyChecked.forEach((key) => {
      const amount = parseFloat(loadedPrice[key]) || 0;
      if (amount || key === "customerOwnInsurance") { // Allow 0 if it's the specific key, though others usually have prices
        prices.total +=
          key === "discount" ? -amount : amount;
        prices[key] = amount;

        if (priceList.insurance1plus5) {
          prices.insurance1plus5 +=
            key === "discount" ? -amount : amount;
        }
        if (priceList.insurance5plus5) {
          prices.insurance5plus5 +=
            key === "discount" ? -amount : amount;
        }
        if (priceList.insurance1plus5ZD) {
          prices.insurance1plus5ZD +=
            key === "discount" ? -amount : amount;
        }
        if (priceList.insurance5plus5ZD) {
          prices.insurance5plus5ZD +=
            key === "discount" ? -amount : amount;
        }
      }
    });

    newlyUnchecked.forEach((key) => {
      const amount = parseFloat(loadedPrice[key]) || 0;
      if (amount || key === "customerOwnInsurance") {
        prices.total +=
          key === "discount" ? amount : -amount;
        delete prices[key];

        if (priceList.insurance1plus5) {
          prices.insurance1plus5 +=
            key === "discount" ? amount : -amount;
        }
        if (priceList.insurance5plus5) {
          prices.insurance5plus5 +=
            key === "discount" ? amount : -amount;
        }
        if (priceList.insurance1plus5ZD) {
          prices.insurance1plus5ZD +=
            key === "discount" ? amount : -amount;
        }
        if (priceList.insurance5plus5ZD) {
          prices.insurance5plus5ZD +=
            key === "discount" ? amount : -amount;
        }
      }
    });

    setOthersChecked(checked);
    setPriceList({ ...prices });
  };

  const fetchPrice = (data) => {
    let total = 0,
      source = [];
    priceType.forEach((type) => {
      if (data[type.key] && Number(data[type.key]) !== 0) {
        const val = parseFloat(data[type.key]) || 0;
        source.push({ type: type.title, price: val });
        if (type.key === "discount") {
          total -= val;
        } else total += val;
      }
    });

    setPriceList({ total });
    setDataSource(source);
    return total;
  };

  const carouselChange = (e) => {
    data.color = selectedId ? price.colors[e].colorId : vehicle.image[e].id;
  };

  const selectInsurance = (insuranceType) => {
    isCheckedInsurance(insuranceType);
  };

  const calculateOthersTotal = (checked, mockPrice = {}, mockTotal = {}) => {
    setOthersChecked(checked);
    const loadedPrice = mockPrice.id ? mockPrice : price;
    let prices = mockTotal.total ? mockTotal : priceList;
    others.forEach((type) => {
      if (prices[type.key]) {
        delete prices[type.key];
      }
      if (checked.includes(type.key)) {
        const amount = loadedPrice[type.key] || 0;
        prices = {
          ...prices,
          total: prices.total + amount,
          // [type.key]: loadedPrice[type.key]
        };
        if (checkedList.includes("insurance1plus5")) {
          prices = {
            ...prices,
            insurance1plus5: prices.total + (loadedPrice.insurance1plus5 || 0),
          };
        }
        if (checkedList.includes("insurance5plus5")) {
          prices = {
            ...prices,
            insurance5plus5: prices.total + (loadedPrice.insurance5plus5 || 0),
          };
        }
        if (checkedList.includes("insurance1plus5ZD")) {
          prices = {
            ...prices,
            insurance1plus5ZD: prices.total + (loadedPrice.insurance1plus5ZD || 0),
          };
        }
        if (checkedList.includes("insurance5plus5ZD")) {
          prices = {
            ...prices,
            insurance5plus5ZD: prices.total + (loadedPrice.insurance5plus5ZD || 0),
          };
        }
      }
    });
    setPriceList({ ...prices });
  };

  return (
    <Form>
      <Row type="flex" justify="space-around">
        <Col xs={24} md={11} style={{ backgroundColor: "white" }}>
          <Item>
            {/* {vehicle &&
              (vehicle.image ? (
                (vehicle.image.url && (
                  <img
                    src={vehicle.image.url}
                    alt="Vehicle"
                    width="100%"
                    onError={(event) => (event.target.src = placeholder)}
                  />
                )) ||
                (vehicle.image[0] && (
                  <img
                    src={vehicle.image[0].url}
                    alt="Vehicle"
                    width="100%"
                    onError={(event) => (event.target.src = placeholder)}
                  />
                ))
              ) : (
                <img width="100%" src={placeholder} alt="Vehicle" />
              ))} */}
            <Carousel
              afterChange={carouselChange}
              style={{ backgroundColor: "white" }}
            >
              {selectedId
                ? price?.colors &&
                  price.colors.map((obj, index) => (
                    <div key={index} style={{ backgroundColor: "white" }}>
                      <img
                        src={obj.imageDetails[0].url}
                        alt={obj.imageDetails[0].color}
                        style={{
                          width: "90%",
                          height: "90%",
                          marginLeft: "15px",
                          marginTop: "20px",
                        }}
                      />
                      <span style={{ color: "black" }}>
                        Color : {obj.imageDetails[0].color}
                      </span>
                    </div>
                  ))
                : vehicle &&
                  vehicle.image.map((obj, index) => (
                    <div key={index} style={{ backgroundColor: "white" }}>
                      <img
                        src={obj.url}
                        alt={obj.color}
                        style={{
                          width: "90%",
                          height: "90%",
                          marginLeft: "15px",
                          marginTop: "20px",
                        }}
                      />
                      <span style={{ color: "black" }}>
                        Color : {obj.color}
                      </span>
                    </div>
                  ))}
            </Carousel>
          </Item>
          <Item>
            {vehicle && (
              <Row>
                <Text strong>Model : </Text>
                <Text>{vehicle.modelName + " - " + vehicle.modelCode}</Text>
              </Row>
            )}
          </Item>
        </Col>
        <Col xs={24} md={12}>
          <Col xs={24} md={12}>
            <Row>
              {vehicle && price && (
                <Item label={<Text>Insurance Type</Text>} colon={true}>
                  <Checkbox.Group
                    disabled={!editable}
                    onChange={(checked) => {
                      calculateTotal(checked);
                      selectInsurance(checked);
                    }}
                    value={insuranceChecked}
                  >
                    <Row type="flex" justify="space-between">
                      {insTypes.map((types) => {
                        if (price[types.key] && Number(price[types.key]) !== 0) {
                          return (
                            <Col key={types.key} span={22}>
                              <Checkbox value={types.key}>
                                {types.title} - &#8377;
                                {price[types.key]}
                              </Checkbox>
                            </Col>
                          );
                        }
                      })}
                    </Row>
                  </Checkbox.Group>
                </Item>
              )}
            </Row>
          </Col>
          <Col xs={24} md={12}>
            <Row>
              {vehicle && price && (
                // <Item label={<Text>Others</Text>} colon={false}>
                //   {getFieldDecorator("others", {
                //     rules: [{ required: false, message: "Select Any Type" }],
                //   })(
                //     <Checkbox.Group
                //       disabled={!editable}
                //       onChange={(checked) => {
                //         calculateAMCRSATotal(checked);
                //       }}
                //     >
                //       <Row type="flex" justify="space-between">
                //         {others.map((types) => {
                //           if (price[types.key]) {
                //             return (
                //               <Col span={22}>
                //                 <Checkbox key={types.key} value={types.key}>
                //                   {types.title} - &#8377;
                //                 {price[types.key]}
                //                 </Checkbox>
                //               </Col>
                //             );
                //           }
                //         })}
                //       </Row>
                //     </Checkbox.Group>
                //   )}
                // </Item>
                <Item label={<Text>Others</Text>} colon={false}>
                  <Checkbox.Group
                    disabled={!editable}
                    onChange={(checked) => {
                      calculateAMCRSATotal(checked);
                    }}
                    value={otherChecked}
                  >
                    <Row type="flex" justify="space-between">
                      {others.map((types) => {
                        if (price[types.key] && Number(price[types.key]) !== 0) {
                          return (
                            <Col key={types.key} span={22}>
                              <Checkbox value={types.key}>
                                {types.title} - &#8377;{price[types.key]}
                                {types.key === "otherCharges" &&
                                  price.accessoriesRemarks && (
                                    <>
                                      <span
                                        style={{
                                          fontSize: "13px",
                                          color: "#888",
                                        }}
                                      >
                                        {" ("}
                                        {price.accessoriesRemarks}
                                        {")"}
                                      </span>
                                    </>
                                  )}
                              </Checkbox>
                            </Col>
                          );
                        }
                      })}
                    </Row>
                  </Checkbox.Group>
                </Item>
              )}
            </Row>
          </Col>
          {/* <Row>
            {vehicle&&vehicle.image  && (
              <Item label={<Text>Color Selection</Text>} colon={false}>
               
                  <Checkbox.Group
                    disabled={!editable}
                    onChange={(checked) => {
                      let id=checked[0];
                      setColorSelected(id)
                    }}
                    value={[colorSelected]}
                  >
                    <Row type="flex" justify="space-between">
                      {vehicle.image.map((types) => {
                          return (
                            <Col span={12}>
                              <Checkbox key={types.id} value={types.id}>
                                {types.color}
                              </Checkbox>
                            </Col>
                          );
                        
                      })}
                    </Row>
                  </Checkbox.Group>
                
              </Item>
            )}
          </Row> */}
          {!editable ? (
            <></>
            // <Row>
            //   <Item label={<Text>Color Select</Text>} colon={false}>
            //     <span>
            //       <b>
            //         {data.color
            //           ? data.color.color
            //           : "No color Selected for this Model"}
            //       </b>
            //     </span>
            //   </Item>
            // </Row>
          ) : (
            <span></span>
          )}
          <Row>
            <Item>
              <PriceTable dataSource={dataSource} />
            </Item>
            <Item>
              <TaxTable dataSource={[priceList]} />
            </Item>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

const PriceForm = Form.create({ name: "image" })(PriceModal);

export default PriceForm;
